module.exports = __webpack_public_path__ + "img/LR-anwendungsgebiete_BEWEGLICHKEIT_seite01-hintergrund.4ad42d27.jpg";